import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        // Off-state now uses a clearly visible mid-grey track (was `bg-input`,
        // which sat almost invisibly close to card/accent surfaces). Hover
        // darkens it slightly for affordance. Works in both themes.
        'peer data-[state=checked]:bg-emerald data-[state=unchecked]:bg-muted-foreground/35 hover:data-[state=unchecked]:bg-muted-foreground/50 focus-visible:border-ring focus-visible:ring-ring/50 inline-flex h-[22px] w-10 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          // Always-white thumb with a soft shadow reads as a lifted knob on
          // both the grey (off) and emerald (on) tracks, in light and dark.
          'bg-white pointer-events-none block size-[18px] rounded-full shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%--1px)] data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
